import {
	AddBrandingLogoAgentOfficeProps,
	AddBrandingLogoAgentProps,
} from "types";

import { axiosWithAuth } from "../../helpers";

export const brandingService = {
	// Agent Office
	getBrandingSettingsAgentOffice,
	setBrandingAlignmentSettingsAgentOffice,
	setBrandingColorsSettingsAgentOffice,
	applyBrandingSettingsAgentOffice,
	disableBrandingSettingsAgentOffice,
	getBrandingLogoAgentOffice,
	addBrandingLogoAgentOffice,
	deleteDocumentLogoAgentOffice,
	setSupportingMessageAgentOffice,
	// Agent
	getBrandingSettingsAgent,
	setBrandingAlignmentSettingsAgent,
	setBrandingColorsSettingsAgent,
	applyBrandingSettingsAgent,
	disableBrandingSettingsAgent,
	addBrandingLogoAgent,
	deleteDocumentLogoAgent,
	setSupportingMessageAgent,
	takeSettingsFromAgentOffice,
	takeSettingsFromAgent,
};

const API_URL = process.env.REACT_APP_API_URL;

function getBrandingSettingsAgentOffice({ companyId }) {
	const options = {
		url: `${API_URL}/api/companies/${companyId}/branding`,
	};

	return axiosWithAuth(options);
}

function setBrandingAlignmentSettingsAgentOffice({ companyId, settings }) {
	const options = {
		method: "POST",
		url: `${API_URL}/api/companies/${companyId}/branding/change_alignments`,
		data: settings,
	};

	return axiosWithAuth(options);
}

function setBrandingColorsSettingsAgentOffice({ companyId, settings }) {
	const options = {
		method: "POST",
		url: `${API_URL}/api/companies/${companyId}/branding/change_colors`,
		data: settings,
	};

	return axiosWithAuth(options);
}

function applyBrandingSettingsAgentOffice({ companyId }) {
	const options = {
		method: "POST",
		url: `${API_URL}/api/companies/${companyId}/branding/apply_settings`,
	};

	return axiosWithAuth(options);
}

function disableBrandingSettingsAgentOffice({ companyId }) {
	const options = {
		method: "POST",
		url: `${API_URL}/api/companies/${companyId}/branding/disable_settings`,
	};

	return axiosWithAuth(options);
}

function getBrandingLogoAgentOffice({ companyId }) {
	//Add random version to prevent loading img from cache
	let randomVersion = Math.random();

	let user = JSON.parse(localStorage.getItem("user") || "");
	return fetch(
		`${API_URL}/api/companies/${companyId}/branding/logo?token=${user.access_token}&v${randomVersion}`,
	);
}

function addBrandingLogoAgentOffice({
	companyId,
	document,
}: AddBrandingLogoAgentOfficeProps) {
	let formData = new FormData();
	let file = document.file;

	formData.append("File", file);
	formData.append("Name", document.name);
	formData.append("Extension", file.name.split(/[.]+/).pop() || "");

	return axiosWithAuth({
		method: "POST",
		url: `${API_URL}/api/companies/${companyId}/branding/logo`,
		data: formData,
		headers: { "Content-Type": undefined },
	});
}

function deleteDocumentLogoAgentOffice({ companyId }) {
	const options = {
		method: "DELETE",
		url: `${API_URL}/api/companies/${companyId}/branding/logo`,
	};

	return axiosWithAuth(options);
}

function setSupportingMessageAgentOffice({ companyId, settings }) {
	const options = {
		method: "POST",
		url: `${API_URL}/api/companies/${companyId}/branding/change_supporting_message`,
		data: settings,
	};

	return axiosWithAuth(options);
}

// Branding for Agent
function getBrandingSettingsAgent({ agentId }) {
	const options = {
		url: `${API_URL}/api/agents/${agentId}/branding`,
	};

	return axiosWithAuth(options);
}
function setBrandingAlignmentSettingsAgent({ agentId, settings }) {
	const options = {
		method: "POST",
		url: `${API_URL}/api/agents/${agentId}/branding/change_alignments`,
		data: settings,
	};

	return axiosWithAuth(options);
}

function setBrandingColorsSettingsAgent({ agentId, settings }) {
	const options = {
		method: "POST",
		url: `${API_URL}/api/agents/${agentId}/branding/change_colors`,
		data: settings,
	};

	return axiosWithAuth(options);
}

function applyBrandingSettingsAgent({ agentId }) {
	const options = {
		method: "POST",
		url: `${API_URL}/api/agents/${agentId}/branding/apply_settings`,
	};

	return axiosWithAuth(options);
}

function takeSettingsFromAgentOffice({ agentId }) {
	const options = {
		method: "POST",
		url: `${API_URL}/api/agents/${agentId}/branding/take_from_agent_office`,
	};
	return axiosWithAuth(options);
}

function takeSettingsFromAgent({ agentId }) {
	const options = {
		method: "POST",
		url: `${API_URL}/api/agents/${agentId}/branding/take_from_agent`,
	};
	return axiosWithAuth(options);
}

function disableBrandingSettingsAgent({ agentId }) {
	const options = {
		method: "POST",
		url: `${API_URL}/api/agents/${agentId}/branding/disable_settings`,
	};

	return axiosWithAuth(options);
}

function addBrandingLogoAgent({
	agentId,
	document,
}: AddBrandingLogoAgentProps) {
	let formData = new FormData();
	let file = document.file;

	formData.append("File", file);
	formData.append("Name", document.name);
	formData.append("Extension", file.name.split(/[.]+/).pop() || "");

	return axiosWithAuth({
		method: "POST",
		url: `${API_URL}/api/agents/${agentId}/branding/logo`,
		data: formData,
		headers: { "Content-Type": undefined },
	});
}

function deleteDocumentLogoAgent({ agentId }) {
	const options = {
		method: "DELETE",
		url: `${API_URL}/api/agents/${agentId}/branding/logo`,
	};

	return axiosWithAuth(options);
}

function setSupportingMessageAgent({ agentId, settings }) {
	const options = {
		method: "POST",
		url: `${API_URL}/api/agents/${agentId}/branding/change_supporting_message`,
		data: settings,
	};

	return axiosWithAuth(options);
}
